import React from 'react';
import __ from 'lodash';

class DropdownGuru extends React.Component{
    render() {
        // console.log('Dropdown Guru Cek = ', this.props.guru);
        return (
            this.props.guru.map((val) =>
                <option key={val.idGuru} value={val.idGuru}>{val.namaGuru}</option>
            )            
        )
    }
}

export default DropdownGuru;